import React from "react";
import {
  Modal,
  Paper,
  Typography,
  IconButton,
  Grid,
  CardContent,
  CardMedia,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const NoteDetail = ({
  open,
  close,
  note,
}) => {

  if (!note) return null;

  return (
    <Modal open={open} onClose={close}>
      <Paper
        elevation={2}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          width: "70%",
          height: "85%",
          display: "flex",
          flexDirection: "column",
          outline: "none",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Typography variant="h6">Detalles de la nota</Typography>
          <IconButton onClick={close}>
            <CloseIcon />
          </IconButton>
        </div>

        <div style={{ flex: 1, overflowY: "auto" }}>
          <Grid container spacing={5} style={{ padding: "15px" }}>
            <Grid item xs={12} md={4}>
            {note.imagen === null ?
              <Typography
                variant="h7"
                color="textSecondary"
                component="div"
              >
                Sin imagen
              </Typography>
            :
              <CardMedia
                component="img"
                style={{ width: "100%", height: "auto", borderRadius: "25px" }}
                image={note.imagen || "/icon.png"}
                alt={note.titulo}
              />
            }
            </Grid>
            <Grid item xs={12} md={8}>
              <CardContent style={{ padding: "0" }}>
                <div style={{ marginBottom: "10px" }}>
                  <Typography
                    variant="h6"
                    color="textSecondary"
                    component="div"
                  >
                    Título de la nota:
                  </Typography>
                  <Typography
                    variant="h7"
                    color="textSecondary"
                    component="div"
                    style={{ marginLeft: "10px" }}
                  >
                    {note.titulo}
                  </Typography>
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <Typography
                    variant="h6"
                    color="textSecondary"
                    component="div"
                  >
                    Síntesis:
                  </Typography>
                  <Typography
                    variant="h7"
                    color="textSecondary"
                    component="div"
                    style={{ marginLeft: "10px" }}
                  >
                    {note.sintesis}
                  </Typography>
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <Typography
                    variant="h6"
                    color="textSecondary"
                    component="div"
                  >
                    Testigo:
                  </Typography>
                  <Typography
                    variant="h7"
                    color="textSecondary"
                    component="div"
                    style={{ marginLeft: "10px" }}
                  >
                    {note.nombre_testigo}
                  </Typography>
                </div>
              </CardContent>
            </Grid>
          </Grid>
        </div>
      </Paper>
    </Modal>
  );
};
